<template>
  <NuxtLayout>
    <AccommodationsListing :page="page" />
  </NuxtLayout>
</template>

<script setup lang="ts">
  defineOptions({
    auth: 'aminess'
  });
  
  defineProps({
    page: {
      type: Object
    }
  });
  
  useHead({
    htmlAttrs: {
      class: 'fixedHeader',
    },
  });
</script>